<template>
  <div class="fnb-popcorn-container">
    <div class="row fnb-item-list" v-if="smCardView">
      <div
        class="py-3 col-3"
        style="max-width:20% !important"
        v-for="(food, key) in getFnbItem"
        :key="key"
        v-if="food.isAvailableToday"
        :class="!checkDisableItem(food) ? 'outOfStockItem' : ''"
      >
        <!---New Design Start-->
        <div
          class="newCard row justify-content-between align-items-center d-block"
          @click="
            onAddFnBList({ ...food, itemIndex: key });
            onAddFnbItemCallback();
          "
          :style="
            !!food.fc_bgColor
              ? `background-color: ${food.fc_bgColor}`
              : 'background-color: var(--lightblue)'
          "
        >
          <!-- style="font-size:12px" -->
          <div class="product-action">
            <div class="">
              <div
                class="px-1 d-flex flex-wrap font-weight-bold"
                :title="food.item_name"
                :style="
                  !!food.fc_fontColor
                    ? `color: ${food.fc_fontColor}`
                    : 'color: var(--text)'
                "
              >
                <span class="pt-1 font-size-respon mb-1">
                  {{ food.item_name || food.recipe_name }}
                </span>
              </div>
            </div>
          </div>

          <div class="px-1 d-flex justify1024 pb-1 respon-gap">
            <div class="d-flex align-items-center m-0 ">
              <div
                class="food-img img-hover br-10"
                style="cursor: pointer; border-radius: 10px"
              >
                <img
                  v-if="food.item_image_url"
                  v-lazy="food.item_image_url"
                  :class="food.item_image_url ? 'custom_width' : ''"
                />
                <!-- <img v-else-if="!food.item_image_url" v-lazy="food.fc_icon_url" class=""/> -->
                <img
                  v-else-if="food.fc_icon_url"
                  v-lazy="food.fc_icon_url"
                  :class="
                    food.item_image_url != null
                      ? 'icon_img' ||
                        food.fc_icon_url.toLowerCase().includes('icon')
                      : 'custom_icon_img'
                  "
                />
                <!-- :height="food.fc_icon_url.toLowerCase().includes('icon') ? '80' : '' " 
              :width="food.fc_icon_url.toLowerCase().includes('icon') ? '90' : '' " -->

                <img v-else v-lazy="food.item_image_url" class="custom_width" />
                <!-- :height="!food.fc_icon_url.toLowerCase().includes('png') ? '80' : '' " 
              :width="!food.fc_icon_url.toLowerCase().includes('png') ? '90' : '' "  -->
                <!-- 
              <img v-else-if="" v-lazy="food.item_image_url" height="80" width="90"/> -->
              </div>
            </div>
            <div class="py-1">
              <!-- product-name -->
              <div
                v-if="false"
                class="font-weight-bold"
                :title="food.item_name"
                :style="
                  !!food.fc_fontColor
                    ? `color: ${food.fc_fontColor}`
                    : 'color: var(--text)'
                "
              >
                {{ food.item_name || food.recipe_name }}
                <FoodMark
                  :isVeg="food.item_is_veg == 'Y' ? true : false"
                  :isEgg="food.includes_egg == 'Y' ? true : false"
                />
              </div>
              <div class="d-block justify-content-between">
                <div class="d-block align-items-center">
                  <!-- 
                     -->
                  <span
                    v-if="
                      food.has_alternate_items &&
                        food.has_alternate_items == 'Y'
                    "
                    class="start-text s_price_text"
                    :style="
                      !!food.fc_fontColor
                        ? `color: ${food.fc_fontColor}`
                        : 'color: var(--text)'
                    "
                  >
                    Starts:
                  </span>
                  <span class="word_break">
                    <strong
                      :style="
                        !!food.fc_fontColor
                          ? `color: ${food.fc_fontColor}`
                          : 'color: var(--text)'
                      "
                      class="custon-fs-12"
                      >&nbsp;{{ food.fp_total_amount }}&nbsp;{{
                        getFnBCurrency.curr_code | uppercase
                      }}</strong
                    >
                  </span>
                </div>
                <div class="icon-positioning">
                  <FoodMark
                    :isVeg="food.item_is_veg == 'Y' ? true : false"
                    :isEgg="food.includes_egg == 'Y' ? true : false"
                  />
                </div>
                <!-- <span :id="'tooltip-fnb-add-button-disable-' + (key + 1)">
                    <button
                      :class="food.isItemInStock ? 'c-pointer click-anim' : ''"
                      v-bind:style="{
                        'pointer-events': !food.isItemInStock ? 'none' : 'all',
                      }"
                      class="btn-pos-add-white combo-btn-style"
                    >
                      +
                    </button>
                  </span> -->
              </div>
              <b-tooltip
                :disabled="food.isItemInStock"
                :target="'tooltip-fnb-add-button-disable-' + (key + 1)"
                placement="top"
                >{{ food.item_name || food.recipe_name }} is not available in
                stock
              </b-tooltip>
            </div>
          </div>
        </div>

        <!---New Design End-->

        <!--Old design Start-->
        <div
          v-if="false"
          class="newCard row"
          @click="
            onAddFnBList({ ...food, itemIndex: key });
            onAddFnbItemCallback();
          "
          :style="
            !!food.fc_bgColor
              ? `background-color: ${food.fc_bgColor}`
              : 'background-color: var(--lightblue)'
          "
        >
          <div class="col-5 d-flex align-items-center m-0 pl-1 p-0">
            <div
              class="food-img img-hover br-10"
              style="cursor: pointer; border-radius: 10px"
            >
              <img
                v-if="food.item_image_url"
                v-lazy="food.item_image_url"
                class="icon_img"
              />
              <!-- <img v-else-if="!food.item_image_url" v-lazy="food.fc_icon_url" class=""/> -->
              <img
                v-else-if="food.fc_icon_url"
                v-lazy="food.fc_icon_url"
                :class="
                  food.fc_icon_url.toLowerCase().includes('png')
                    ? 'icon_img'
                    : ''
                "
                :height="
                  food.fc_icon_url.toLowerCase().includes('icon') ? '80' : ''
                "
                :width="
                  food.fc_icon_url.toLowerCase().includes('icon') ? '90' : ''
                "
              />
              <img v-else v-lazy="food.item_image_url" height="80" width="90" />
              <!-- :height="!food.fc_icon_url.toLowerCase().includes('png') ? '80' : '' " 
              :width="!food.fc_icon_url.toLowerCase().includes('png') ? '90' : '' "  -->
              <!-- 
              <img v-else-if="" v-lazy="food.item_image_url" height="80" width="90"/> -->
            </div>
          </div>
          <div class="col-7 py-1 position-parent">
            <!-- product-name -->
            <div
              class="font-weight-bold"
              :title="food.item_name"
              :style="
                !!food.fc_fontColor
                  ? `color: ${food.fc_fontColor}`
                  : 'color: var(--text)'
              "
            >
              {{ food.item_name || food.recipe_name }}
              <FoodMark
                :isVeg="food.item_is_veg == 'Y' ? true : false"
                :isEgg="food.includes_egg == 'Y' ? true : false"
              />
            </div>
            <div class="product-action">
              <div class="" :style="'zoom: 0.8'">
                <div class="d-flex flex-column position-child">
                  <span
                    v-if="
                      food.has_alternate_items &&
                        food.has_alternate_items == 'Y'
                    "
                    class="s_price_text"
                    :style="
                      !!food.fc_fontColor
                        ? `color: ${food.fc_fontColor}`
                        : 'color: var(--text)'
                    "
                  >
                    Starts From</span
                  >
                  <span>
                    <strong
                      :style="
                        !!food.fc_fontColor
                          ? `color: ${food.fc_fontColor}`
                          : 'color: var(--text)'
                      "
                      class="fs-16"
                      >&nbsp;{{ food.fp_total_amount }}&nbsp;{{
                        getFnBCurrency.curr_code | uppercase
                      }}</strong
                    >
                  </span>
                  <!-- <span :id="'tooltip-fnb-add-button-disable-' + (key + 1)">
                    <button
                      :class="food.isItemInStock ? 'c-pointer click-anim' : ''"
                      v-bind:style="{
                        'pointer-events': !food.isItemInStock ? 'none' : 'all',
                      }"
                      class="btn-pos-add-white combo-btn-style"
                    >
                      +
                    </button>
                  </span> -->
                </div>
                <b-tooltip
                  :disabled="food.isItemInStock"
                  :target="'tooltip-fnb-add-button-disable-' + (key + 1)"
                  placement="top"
                  >{{ food.item_name || food.recipe_name }} is not available in
                  stock
                </b-tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-else>
      <div
        class="food-card-container"
        v-for="(food, key) in getFnbItem"
        :key="key"
        v-if="food.isAvailableToday"
        :class="!checkDisableItem(food) ? 'outOfStockItem' : ''"
      >
        <div class="food-card">
          <div class="fnb-food-info" @click="showFnBDetails(food)">
            <img src="@/assets/img/icons/info.svg" height="auto" width="28" />
          </div>

          <div
            class="food-img img-hover"
            @click="
              onAddFnBList({ ...food, itemIndex: key });
              onAddFnbItemCallback();
            "
            style="cursor: pointer"
          >
            <img v-lazy="food.item_image_url" class="img-fluid" />
          </div>
          <div
            class="details"
            @click="
              onAddFnBList({ ...food, itemIndex: key });
              onAddFnbItemCallback();
            "
            :style="
              !!food.fc_bgColor
                ? `background-color: ${food.fc_bgColor}`
                : 'background-color: var(--lightblue)'
            "
          >
            <div
              class="text-uppercase font-weight-bold"
              :style="
                !!food.fc_fontColor
                  ? `color: ${food.fc_fontColor}`
                  : 'color: var(--text)'
              "
            >
              {{ food.item_name || food.recipe_name }}
            </div>

            <div
              class="
                text-white
                d-flex
                align-items-center
                justify-content-between
                mr-1
              "
            >
              <span
                v-if="
                  food.has_alternate_items && food.has_alternate_items == 'Y'
                "
                class="s_price_text"
                :style="
                  !!food.fc_fontColor
                    ? `color: ${food.fc_fontColor}`
                    : 'color: var(--text)'
                "
              >
                Starts From</span
              >
              <strong
                :style="
                  !!food.fc_fontColor
                    ? `color: ${food.fc_fontColor}`
                    : 'color: var(--text)'
                "
                >{{ food.fp_total_amount }}
                {{ getFnBCurrency.curr_code | uppercase }}</strong
              >
              <span :id="'tooltip-fnb-add-button-disable-' + (key + 1)">
                <div
                  :class="food.isItemInStock ? 'c-pointer click-anim' : ''"
                  v-bind:style="{
                    'pointer-events': !food.isItemInStock ? 'none' : 'all',
                  }"
                >
                  <!-- fetchFnbOffersList();fetchFnbVouchersList(); -->
                  <div style="width: 30px">
                    <svg
                      :fill="
                        `${!!food.fc_fontColor ? food.fc_fontColor : '#fff'}`
                      "
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      width="30px"
                      height="30px"
                      viewBox="0 0 510 510"
                      style="enable-background: new 0 0 510 510"
                      xml:space="preserve"
                    >
                      <path
                        d="M280.5,153h-51v76.5H153v51h76.5V357h51v-76.5H357v-51h-76.5V153z M255,0C114.75,0,0,114.75,0,255s114.75,255,255,255
                          s255-114.75,255-255S395.25,0,255,0z M255,459c-112.2,0-204-91.8-204-204S142.8,51,255,51s204,91.8,204,204S367.2,459,255,459z"
                      />
                    </svg>
                  </div>
                </div>
              </span>
              <b-tooltip
                :disabled="food.isItemInStock"
                :target="'tooltip-fnb-add-button-disable-' + (key + 1)"
                placement="top"
                >{{ food.item_name || food.recipe_name }} is not available in
                stock</b-tooltip
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapActions } from "vuex";
  import _ from "lodash";
  import { BASEURL } from "@/config/index";
  import FoodMark from "@/components/UIElements/VegMark.vue";

  export default {
    components: {
      FoodMark,
    },
    props: {
      foodItems: {
        type: Array,
        default: [],
      },
    },
    data() {
      return {
        BASEURL,
        smCardView: true,
      };
    },
    computed: {
      ...mapGetters([
        "fnbItems",
        "getFnBCurrency",
        "SelectedFnbItemList",
        "selectedFnBItemsTotalPrice",
        "AdditionalTaxList",
      ]),
      getFnbItem() {
        let fnbItemNew =
          this.fnbItems && this.fnbItems.length
            ? _.orderBy(this.fnbItems, (i) => String(i.item_name).trim())
            : [];

        fnbItemNew.sort(function(a, b) {
          return b.hasOwnProperty("availableInVendorRates") &&
            b.availableInVendorRates == "N"
            ? -1
            : 1;
        });

        return fnbItemNew;
      },
    },
    mounted() {},
    methods: {
      ...mapActions([
        "onAddFnBList",
        "showFnBDetails",
        "fetchFnbOffersList",
        "fetchFnbVouchersList",
      ]),
      checkDisableItem(item) {
        if (
          item.hasOwnProperty("availableInVendorRates") &&
          item.availableInVendorRates == "N"
        ) {
          return false;
        } else {
          return true;
        }
      },
      // GetAdditional: async function() {
      //   let fnboffer = this.fetchFnbOffersList;

      //   return await Promise.all(fnboffer);

      //   let selectedItem = await this.SelectedFnbItemList;
      //   if (selectedItem.length > 0) {
      //     let response = await this.AdditionalTaxList;
      //     if (response.length > 0) {
      //       console.log("response :", response);
      //       this.onEmitSocket();
      //     }
      //   }
      // },
      onEmitSocket: async function() {
        if (this.$socket) {
          setTimeout(() => {
            let charges = this.AdditionalTaxList;
            this.$socket.emit("main_brij_FnB_flag_change", {
              flag: true,
              fnbItems: this.SelectedFnbItemList,
              curr_code: this.getFnBCurrency.curr_code,
              charges: charges,
            });
          }, 1000);
        }
      },
      onAddFnbItemCallback: _.debounce(function() {
        this.fetchFnbOffersList();
        this.fetchFnbVouchersList();
        this.onEmitSocket();
      }, 200),
    },
  };
</script>

<style>
  .outOfStockItem {
    pointer-events: none;
    opacity: 0.5;
  }

  .outOfStockItem::before {
    content: "No Stock";
    position: absolute;
    display: flex;
    align-items: center;
    height: 125px;
    width: 100%;
    justify-content: center;
    font-size: 21px;
    font-weight: bold;
    text-transform: uppercase;
    /* color: #4d4b4b; */
    color: red;
  }

  .fnb-popcorn-container {
    padding-left: 15px;
    padding-right: 15px;
    height: 100%;
    max-height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .food-card-container {
    margin-bottom: 25px;
    width: calc(100% / 4);
  }

  @media (min-width: 1200px) {
    .food-card-container {
      width: calc(100% / 4);
    }
  }

  @media (min-width: 1600px) {
    .food-card-container {
      width: calc(100% / 5);
    }
  }

  .pos-fnb-clearSearch {
    width: 50px;
    font-size: 45px;
    line-height: 0.95;
    text-align: center;
    background-color: #fff;
    color: #d3d3d3;
  }

  .food-card {
    width: 80%;
    height: 200px; /*230px*/
    overflow: hidden;
    position: relative;
    border-radius: var(--posFnbGlobalRadius);
    background-color: #fff;
    box-shadow: 4px 5px 12px -7px;
  }

  .food-card .food-img {
    width: 100%;
    display: flex;
    align-items: center;
    overflow: hidden;
    text-align: center;
    justify-content: center;
    height: calc(100% - 90px);
  }

  .food-card .food-img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .food-card .details {
    left: 0;
    bottom: 0;
    width: 100%;
    height: 110px;
    padding: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    text-align: center;
    position: absolute;
    background-color: var(--lightblue);
  }

  .fnb-popcorn-container::-webkit-scrollbar {
    width: 15px;
    margin-left: 20px;
  }

  .s_price_text {
    /* position: absolute; */
    /* bottom: 30px; */
    /* bottom: 50px; */
    font-size: 13px;
    font-weight: 500;
  }

  .product-name {
    font-weight: bold;
    font-size: 13px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 40px;
  }
  .position-parent {
    position: relative;
  }
  /* .icon-positioning{
  position: absolute;
  right: 0px;
} */
  .position-child {
    position: absolute;
    bottom: 0;
  }
  .custom_icon_img {
    width: 80px !important;
    height: 70px;
    display: flex;
    /* margin: auto; */
    padding: 10px;
    border-radius: 10px;
    /* filter: invert(100%);
  -webkit-filter: invert(100%); */
    background-color: white;
  }
  .icon_img {
    width: 80px !important;
    height: 70px;
    display: flex;
    /* margin: auto; */
    padding: 10px;
    border-radius: 10px;
    background-color: white;
  }
  .custom_width {
    width: 80px !important;
    height: 70px !important;
    border-radius: 10px;
    background-color: white;
    padding: 10px;
  }
  .back_white {
    background-color: white !important;
  }
  .start-text {
    /* font-weight: bold; */
    font-size: 12px;
    display: flex;
    align-items: center;
  }
  .respon-gap {
    gap: 10px;
  }
  .word_break {
    word-break: break-all;
  }
  @media screen and (min-width: 1020px) and (max-width: 1250px) {
    .icon_img {
      width: 75px !important;
      height: 70px;
      display: flex;
      /* margin: auto; */
      padding: 5px;
      border-radius: 10px;
      background-color: white;
    }
    .custom_width {
      width: 75px !important;
      height: 70px !important;
      padding: 5px;
      border-radius: 10px;
      background-color: white;
    }
    .custom_icon_img {
      width: 75px !important;
      height: 70px !important;
      padding: 5px;
      border-radius: 10px;
      background-color: white;
    }
    .font-size-respon {
      font-size: 12px;
    }
    .respon-gap {
      gap: 6px;
    }
    .custon-fs-12 {
      font-size: 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/PosFnbContainer/posFnbPopcorn.vue